import { mapGetters } from 'vuex'

export default {
  name: 'ToursMixin',

  computed: {
    ...mapGetters({
      // OLDTOUR userTours: 'userDataStore/userTours'
      userTours: 'tourStore/userTours',
      currentTour: 'tourStore/currentTour',
      tour: 'tourStore/tour',
      tours: 'tourStore/tours',
      tourRootId: 'tourStore/tourRootId',
      applicationId: 'contextStore/applicationId'
    }),

    tourTrigger () {
      if (this.dialog !== undefined) {
        return this.dialog
      }
      if (this.mode !== undefined) {
        return this.mode === 'select'
      }
      return true
    },

    tourId () {
      return this.tourTrigger && [
        this.tourRootId,
        this.applicationId,
        this.$options.name,
        this.trackerTypeId
      ].filter(Boolean).join('.')
    },

    localTourId () {
      if (this.tours[this.tourId]) {
        return this.tourId
      }
      return this.tourTrigger && [
        this.tourRootId,
        this.$options.name
      ].join('.')
    }
  },

  mounted () {
    if (!this.currentTour || this.currentTour !== this.localTourId) {
      this.destroy(this.currentTour)
      this.$nextTick(() => {
        this.init(this.localTourId)
      })
    } else {
      this.destroy(this.currentTour)
    }
  },

  beforeDestroy () {
    this.destroy(this.currentTour)
  },

  methods: {
    init (name) {
    // OLDTOUR if (name && this.userTours && !this.userTours.some(tour =>
      if (name && this.userTours && this.userTours.some(tour =>
        tour.id === name &&
        tour.version === this.tours[name]?.version
      )) {
        this.$store.commit('tourStore/setTour', name)
      }
    },
    destroy (name) {
      if (name) {
        this.$store.commit('tourStore/deleteTour', name)
      }
    },
    update () {
      if (this.localTourId) {
        this.destroy(this.currentTour)
        this.init(this.localTourId)
      } else {
        this.destroy(this.currentTour)
      }
    }
  },

  watch: {
    userTours (val, prevVal) {
      // trick to init the tour only when the userProfile is first loaded
      // and not also when a tour is skipped
      if (prevVal === undefined && this.localTourId) {
        this.init(this.localTourId)
      }
    },
    tourId () {
      this.update()
    }
  }
}
